/**
 * Product Description
 * Clamps the PDP description to 3 lines with an inline "...more" / "...less" toggle
 */
function productDescription() {
  const description = document.querySelector(".js-product-description-text");
  const toggle = document.querySelector(".js-product-description-toggle");

  if (!description || !toggle) {
    return;
  }

  const labels = {
    collapsed: toggle.textContent.trim(),
    expanded: "…less"
  };

  function isOverflowing() {
    return description.scrollHeight > description.clientHeight;
  }

  function getLastVisibleLineRect() {
    const range = document.createRange();
    range.selectNodeContents(description);
    range.setEndBefore(toggle);

    const containerRect = description.getBoundingClientRect();
    const lineRects = Array.from(range.getClientRects()).filter((rect) => rect.width > 0);

    let lastVisibleRect = null;

    lineRects.forEach((rect) => {
      if (rect.bottom <= containerRect.bottom + 1) {
        lastVisibleRect = rect;
      }
    });

    return { lastVisibleRect, containerRect };
  }

  /**
   * Positions the toggle immediately after the last visible word
   */
  function positionToggle() {
    const { lastVisibleRect, containerRect } = getLastVisibleLineRect();

    if (!lastVisibleRect) {
      return;
    }

    const maxLeft = Math.max(containerRect.width - toggle.offsetWidth, 0);
    const desiredLeft = lastVisibleRect.right - containerRect.left;

    toggle.style.bottom = "auto";
    toggle.style.right = "auto";
    toggle.style.top = `${lastVisibleRect.top - containerRect.top - 3}px`;
    toggle.style.left = `${Math.min(desiredLeft, maxLeft)}px`;
  }

  function updateToggleVisibility() {
    const isExpanded = description.classList.contains("is-expanded");

    if (isExpanded) {
      toggle.classList.remove("hide");
      positionToggle();
      return;
    }

    const hasOverflow = isOverflowing();

    toggle.classList.toggle("hide", !hasOverflow);

    if (hasOverflow) {
      positionToggle();
    }
  }

  function handleToggleClick() {
    const isExpanded = description.classList.toggle("is-expanded");

    toggle.setAttribute("aria-expanded", isExpanded ? "true" : "false");
    toggle.textContent = isExpanded ? labels.expanded : labels.collapsed;

    updateToggleVisibility();
  }

  toggle.addEventListener("click", handleToggleClick);
  window.addEventListener("resize", updateToggleVisibility);
  updateToggleVisibility();
}

export default productDescription;
